import { render, staticRenderFns } from "./create_plateform.vue?vue&type=template&id=76d5f83f&scoped=true&"
import script from "./create_plateform.vue?vue&type=script&lang=js&"
export * from "./create_plateform.vue?vue&type=script&lang=js&"
import style0 from "./create_plateform.vue?vue&type=style&index=0&id=76d5f83f&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d5f83f",
  null
  
)

export default component.exports